$(document).ready(function ($) {
	// Titulka.init()

	if (typeof Editor != "undefined") return;
	Page.init();

	Promise.all([
		// App.winLoaded(),
		Directory.loadPages(),
		App.loadFonts()
	])
		.then(function () {
			if (App.debug) {
				console.log('****************** all loaded **************************');
			}
			Router.init();
			App.initScroll();

			// Header.init(600);
			Cookiebar.view();

			Menu.init();
			// SearchAutocomplete.init();
			Banner.init();
			Picture.init();
			Popup.init();
			// Expander.init();
			// Ol.init();
			// Table.init();

			// Footer.pinBottom();
			// Articles.init();
			// Datepicker.init();
			// Galeria.Gallery.init();
			$('body').removeClass('hidden');

			SiteFunctions.init();
			Homepage.initVideo();
			Homepage.initAnims();
			ScrollableElement.init();

			Directory.wasLoaded = true;

			setTimeout(function () {
				if (!Router.subpage && App.hasDirectory) Directory.closePage();
				$('.page-content > .row').removeClass('hidden');
			}, 800);

		})
});

var resizeId;
$(window).resize(function () {
	clearTimeout(resizeId);
	resizeId = setTimeout(doneResizing, 300);
});

function doneResizing() {
	Menu.resize();
	// Footer.pinBottom();
	// Titulka.resize();
	// Banner.resize();
	// Expander.init();
	Header.resize();

	// BoxRotator.resize();
}

$(window).load(function () {
});

Titulka = {

	init: function () {
		var video = $('<video id="video" poster="preview-file/video-poster.jpg" playsinline muted loop><source src="' + WEB_ROOT + '/files/1980-5.mp4" type="video/mp4"></video>');
		video.appendTo('body');
		video[0].play();
		this.resize();
	},

	resize: function () {
		console.log('resize');
		if ($('#homepage').height() < 700) return;
		$('#homepage').find('.content').height("auto");
		$('#homepage').find('.content').height($('#homepage').height())
	}
}